import { render, staticRenderFns } from "./GridContainer.vue?vue&type=template&id=741e704c&"
import script from "./GridContainer.vue?vue&type=script&lang=ts&"
export * from "./GridContainer.vue?vue&type=script&lang=ts&"
import style0 from "./GridContainer.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports